//solicitações

import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import Header from "../../components/header/header";
import Pagination from "react-bootstrap/Pagination";
import { Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col, Form } from "react-bootstrap";
import "./solicitacoesListage.css";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPlus, faPencil, faTrashCan, faSearch, faFilter} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { getSolicitacoes } from "../../services/api_solicitacoes_servico";
import { deleteSolicitacao, getSolicitacaoById, updateSolicitacao} from "../../services/api_cadastros_solicitacoes_servico";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import MUIButton from "@mui/material/Button";
import MUIButtonGroup from "@mui/material/ButtonGroup";

import getDateHour from "../../hooks/GetDateHour";
import dataHoraFormatada from "../../hooks/Date/dataHoraFormatada";
import { Permissions } from "../../hooks/Permission/permission";
import Select from 'react-select'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const SolicitacoesListage = () => {
  const navigate = useNavigate();
  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [selectedSituacao, setSelectedSituacao] = useState([]);
  
  const POLLING_INTERVAL = 30000;

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body, isQuestion, qFunc) => {
    setModalContent({ title, body, isQuestion, qFunc });
    setShowModal(true);
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await getSolicitacoes();
      //console.log(response);
      setDados(response.data.solicitacoesServico);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao obter dados:", error);
    }
  }, [])

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchData();
    }, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [fetchData]);

  useEffect(() => {
    filterData();
  }, [searchTerm, dados]);

  const situacaoOptions = [
    { value: 0, label: "Aberta em dia" },
    { value: 1, label: "Aberta em atraso" },
    { value: 2, label: "Fechada em dia" },
    { value: 3, label: "Fechada em atraso" },
    { value: 4, label: "Cancelada" },
  ];

  const situacaoMap = {
    0: "Pendente",
    1: "Aprovada",
    2: "Concluída",
    3: "Cancelada",
  };

  const filterData = () => {
    if (dados) {
      const filtered = dados.filter((item) => {
        const situacaoDescricao = situacaoMap[item.situacao] || "";

        const matchesSearch = searchTerm ? (
          item.id?.toString().includes(searchTerm) ||
          item.solicitacao?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.unidade?.id?.toString().includes(searchTerm) ||
          item.unidade?.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.unidade?.empresa?.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.unidade?.empresa?.id.toString().includes(searchTerm) ||
          situacaoDescricao.toLowerCase().includes(searchTerm.toLowerCase())
        ) : true;

        const matchesSituacao = selectedSituacao && selectedSituacao.length > 0 
          ? selectedSituacao.some((option) => option.value === Number(item.situacao))
          : true;


        return matchesSearch && matchesSituacao;  
      });
      setFilteredData(filtered);
      setCurrentPage(1);  
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = (searchTerm || (selectedSituacao && selectedSituacao.length > 0))
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : dados.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(
    (searchTerm ? filteredData.length : dados.length) / itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const handleGoToEdit = (id) => {
    navigate(`/solicitacao-servico-cadastrar`, { state: { id } });
  };

  const handleDeleteModal = (id) => {
    Swal.fire({
      title: "Tem certeza de que deseja inativar o registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#808B96",
      confirmButtonText: "Inativar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await deleteSolicitacao(id);
          //console.log(response);
          if (response && response.data) {
            //console.log(response);
            const updatedData = dados.filter((item) => item.id !== id);
            setDados(updatedData);
            setShowModal(false);
            setLoading(false);
            return true;
          } else if (response.response.status === 422) {
            if (response.response.data.mensagem) {
              const mensagem = response.response.data.mensagem;
              return Swal.showValidationMessage(`${mensagem}`);
            } else if (response.response.data.errors) {
              const error = response.response.data.errors;
              return Swal.showValidationMessage(`Erro: ${error}`);
            }
          }
        } catch (error) {
          return Swal.showValidationMessage(`
          Erro: ${error}
        `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value) {
          Swal.fire({
            title: "Inativado!",
            text: "O registro foi inativado com sucesso.",
            icon: "success",
            timer: 2500,
          });
        }
      }
    });
  };

  const handleSituacao = (situacao) => {
    switch (situacao) {
      case "0":
        return "Pendente";
      case "1":
        return "Aprovada";
      case "2":
        return "Concluída";
      case "3":
        return "Cancelada";
      default:
        return "Situação desconhecida";
    }
  };

  const handleApprove = async (idSolicitacao, idEmpresa) => {
    try {
      setButtonLoading(true);
      //console.log(idEmpresa);
      const response = await getSolicitacaoById(idSolicitacao);
      if (response && response.status === 200) {
        //console.log(response);
        const solicitacaoData = response.data.solicitacaoServico;
        solicitacaoData["id_empresa"] = idEmpresa;

        if (solicitacaoData["anexo"] != null) {
          const base64Parts = solicitacaoData["anexo"].split(";base64,");
          // Extrai o tipo de conteúdo do cabeçalho
          const contentType = base64Parts[0].split(":")[1];
          // Decodifica o conteúdo base64 para um array de bytes
          const byteCharacters = atob(base64Parts[1]);
          // Converte o array de bytes para um array de números
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          // Cria um blob com o array de números e o tipo de conteúdo
          const blob = new Blob([new Uint8Array(byteNumbers)], {
            type: contentType,
          });

          const fileExtension = contentType.split("/")[1];

          const file = new File([blob], `file.${fileExtension}`, {
            type: contentType,
          });

          solicitacaoData.anexo = file;
        } else {
          delete solicitacaoData.anexo;
        }

        navigate("/ordem-servico-cadastrar", {
          state: { dadosSolicitacao: solicitacaoData },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = async (id) => {
    const updateSolicitationsListage = async () => {
      const response = await getSolicitacoes();
      if (response.status === 200) {
        setDados(response.data.solicitacoesServico);
        return true;
      }

      return false;
    };

    Swal.fire({
      title: "Informe a justificativa do cancelamento da solicitação",
      input: "text",
      icon: "info",
      inputAttributes: {
        autocapitalize: "on",
      },
      showCancelButton: true,
      confirmButtonText: "Enviar justificativa",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#808B96",
      confirmButtonColor: "#28A745",
      showLoaderOnConfirm: true,
      preConfirm: async (inputValue) => {
        const dataHora = getDateHour();
        try {
          if (!inputValue) {
            return Swal.showValidationMessage(
              "Por favor, insira uma justificativa."
            );
          } else if (inputValue.length < 10) {
            return Swal.showValidationMessage(
              "Insira uma justificativa com, no mínimo, 10 caracteres."
            );
          }
          await updateSolicitacao(
            id,
            {
              situacao: "3",
              data_hora_cancelamento: dataHora,
              justificativa_cancelamento: inputValue,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
        } catch (error) {
          console.log(error);
          return Swal.showValidationMessage(
            `Erro ao tentar cancelar a solicitação: ${Object.values(
              error.response.data.errors
            )}`
          );
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Solicitação cancelada com sucesso!",
          text: "Atualizando as solicitações de serviço...",
          icon: "success",
          timer: 2500,
          didOpen: async () => {
            Swal.showLoading();
            await updateSolicitationsListage();
            Swal.close();
          },
        });
      }
    });
  };

  const renderPaginationItems = () => {
    const paginationItems = [];

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    if (currentPage > 3) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    if (totalPages > 1) {
      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  function ExpansibleRow(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow
          className="table-row"
          sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell />
          <TableCell component="th" scope="row">
            {row.id}
          </TableCell>
          <TableCell component="th" scope="row">
            {row.solicitacao}
          </TableCell>
          <TableCell component="th" scope="row">
          {`${row.unidade?.id_empresa} - ${row.unidade?.empresa?.nome || "Unidade Indisponível"}`}
          </TableCell>
          <TableCell component="th" scope="row">
          {`${row.id_unidade} - ${row.unidade?.nome || "Unidade Indisponível"}`}
          </TableCell>
          <TableCell component="th" scope="row">
            {handleSituacao(row.situacao)}
          </TableCell>
          <TableCell
            style={{ justifyContent: "flex-end", borderBottom: "none"}}
            align="left"
            className="d-flex"
          >
            <Permissions
            requiredPermissions={[
              { entidade: 'SolicitacaoServico', actions: ['update'] }
            ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleGoToEdit(row.id)}
                disabled={row.situacao !== "0" ? true : false || row.deleted_at !== null}
              >
                <Link>
                  <FontAwesomeIcon icon={faPencil} size="1x" color={row.situacao === "1" || row.situacao === "2" || row.situacao === "3"|| row.deleted_at !== null ? "gray" : "#1E90FF"} />
                </Link>
              </button>
            </Permissions>
            <Permissions
              requiredPermissions={[
                { entidade: 'SolicitacaoServico', actions: ['delete'] }
              ]}
            >
              <button
                className="btn btn-white text-dark"
                onClick={() => handleDeleteModal(row.id)}
                disabled={row.situacao !== "0" ? true : false || row.deleted_at !== null}
              >
                <FontAwesomeIcon icon={faTrashCan} size="1x" color={row.situacao === "1" || row.situacao === "2" || row.situacao === "3" || row.deleted_at !== null ? "gray" : "#F08080"}  />
              </button>
            </Permissions>

            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <p>
                  <strong>ID: </strong>
                  {row.id}
                </p>
                <p>
                  <strong>Usuário solicitante: </strong>{" "}
                  {`${row.id_user} - ${row.user.name}`}
                </p>
                <p>
                  <strong>Descrição: </strong>
                  {row.solicitacao}
                </p>
                <p>
                  <strong>Aplicação: </strong>
                  {`${row?.id_aplicacao} - ${row.aplicacao?.descricao ?? 'Aplicação Indisponível'}`}
                </p>
                {row.id_unidade && row.unidade && (
                  <p>
                    <strong>Unidade: </strong>{" "}
                    {`${row.id_unidade} - ${row.unidade?.nome ?? 'Unidade Indisponível'}`}
                  </p>
                )}
                {row.unidade?.empresa?.id && row.unidade?.empresa?.nome && (
                  <p>
                    <strong>Empresa: </strong>{" "}
                    {`${row.unidade?.empresa?.id} - ${row.unidade?.empresa?.nome ?? 'Empresa Indisponível'}`}
                  </p>
                )}
                {row.data_hora_aprovacao ? (
                  <p>
                    <strong>Aprovada em: </strong>
                    {dataHoraFormatada(row.data_hora_aprovacao)}
                  </p>
                ) : null}
                <p>
                  <strong>Situação: </strong>
                  {handleSituacao(row.situacao)}
                </p>
                {row.data_hora_cancelamento ? (
                  <p>
                    <strong>Cancelada em: </strong>
                    {dataHoraFormatada(row.data_hora_cancelamento)}
                  </p>
                ) : null}
                {row.justificativa_cancelamento ? (
                  <p>
                    <strong>Justificativa do cancelamento: </strong>
                    {row.justificativa_cancelamento}
                  </p>
                ) : null}
                {row.anexo ? (
                  <>
                    <p>
                      <strong>Anexo:</strong>
                    </p>

                    <p>
                      <img width="250px" src={row.anexo} alt="" />
                    </p>
                  </>
                ) : null}
                {row.situacao === "0" ? (
                  <MUIButtonGroup
                    variant="contained"
                    aria-label="Basic button group"
                    className="text-center shadow-none"
                  >
                    <MUIButton
                      color="info"
                      className="mr-2 bg-light border border-dark rounded-pill"
                      onClick={() =>
                        handleApprove(row.id, row.unidade.id_empresa)
                      }
                      disabled={!!buttonLoading ? true : false}
                    >
                      Aprovar
                    </MUIButton>
                    <MUIButton
                      color="info"
                      className="bg-light border border-dark rounded-pill"
                      onClick={() => handleCancel(row.id)}
                      disabled={!!buttonLoading ? true : false}
                    >
                      Cancelar
                    </MUIButton>
                  </MUIButtonGroup>
                ) : null}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <>
      <Header title="Serviços / Listagem de Solicitações de Serviço" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <div className="mt-4 mb-3">
          <div className="mt-1 mb-3 mt-3">
            <Permissions 
              requiredPermissions={[
                { entidade: 'SolicitacaoServico', actions: ['store'] }
              ]}
            >
              <Link to={`/solicitacao-servico-cadastrar`}>
                <button className="btn btn-light text-dark">
                  <FontAwesomeIcon icon={faPlus} size="1x" color="#006400" />
                </button>
              </Link>
            </Permissions>
          </div>

          {isLoading ? (
            <></>
          ) : (
            <>
              <Row>
                <Col md={1} className="mb-3">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faFilter} size="1x" color="#000000" className="mr-2"/>

                    <Form.Control as="select" value={itemsPerPage} onChange={handleItemsPerPageChange} className="ml-2">
                      {itemsPerPageOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Select
                    isMulti
                    options={situacaoOptions}
                    value={selectedSituacao}
                    onChange={setSelectedSituacao}
                    isClearable
                    placeholder="Filtrar por situação"
                    styles={{
                      control: (base) => ({
                        ...base,
                        maxHeight: '100px',
                        overflowX: 'hidden',   // rolagem horizontal se necessário
                        display: 'flex',
                        flexWrap: 'nowrap',  // impede quebra de linha
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'hidden',
                      }),
                      multiValue: (base) => ({
                        ...base,
                        marginRight: '4px',
                      }),
                    }}
                  />  
                </Col>
                <Col md={3} className="mb-3 ml-auto">
                  <Form.Group className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faSearch}
                      size="1x"
                      color="#000000"
                      className="mr-2"
                    />

                    <Form.Control
                      type="text"
                      placeholder="Digite para pesquisar"
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="ml-2"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </div>

        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Solicitação</StyledTableCell>
                    <StyledTableCell>Empresa</StyledTableCell>
                    <StyledTableCell>Unidade</StyledTableCell>
                    <StyledTableCell>Situação</StyledTableCell>
                    <StyledTableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItems.map((item) => (
                    <ExpansibleRow key={item.id} row={item} />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Pagination className="mt-4">{renderPaginationItems()}</Pagination>
          </>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
        isQuestion={modalContent.isQuestion}
        questionAction={modalContent.qFunc}
      />
    </>
  );
};

export default SolicitacoesListage;
